import { render } from "./profilemodal.vue?vue&type=template&id=1fef068a"
import script from "./profilemodal.vue?vue&type=script&lang=js"
export * from "./profilemodal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__